var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:[ 'node-goal-list', _vm.item.classes ]},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,class:`goal-icon goal-icon-${item.value}`},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getItem(item))}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }